import React from 'react';
import { Link } from 'react-router-dom';

export function LogoMark({ size = 38 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="14" fill="#0B2B1A" />
      <path
        d="M32 9 L52 20.5 V43.5 L32 55 L12 43.5 V20.5 Z"
        fill="none"
        stroke="#F8FAF7"
        strokeWidth="4.5"
      />
      <circle cx="32" cy="32" r="7.5" fill="#FF5722" />
    </svg>
  );
}

export default function Logo({ light = true }) {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group shrink-0">
      <LogoMark />
      <span className="leading-none">
        <span
          className={`font-display font-bold uppercase tracking-tight text-2xl block ${
            light ? 'text-cream' : 'text-forest'
          } group-hover:text-flame transition-colors duration-300`}
        >
          TractorParts <span className="text-flame">USA</span>
        </span>
        <span
          className={`font-mono text-[9px] uppercase tracking-widest2 block mt-0.5 ${
            light ? 'text-cream/50' : 'text-sub'
          }`}
        >
          Quality Parts · Fast Shipping
        </span>
      </span>
    </Link>
  );
}
